export function getAppVersion({ config }) {
  const isWebview = localStorage.getItem('isWebview') === 'true';
  return isWebview ? `webview-${config.APP.APP_RELEASE}` : config.APP.APP_RELEASE;
}
